const baseURL = 'https://willdorstore.com/';

export default baseURL;
